
import React from "react";
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { ApiResponseData, BaseService, EarningService, IMember, ITeam, ITeamAnalytics, ITeamMember, ITeamMemberEarning, ITeamTopProgram, ITeamAchievement, ITeamTransaction, ITournamentEdition, SanitizedResponse, TeamRole, TeamService, TransactionFlow, TournamentService, TransactionSourceType, ITeamAchievementDetail, TeamAchievementType, TeamAchievementPlace } from "../../../../services";
import { ChartData, ChartType, Classname, Column, DateHelper, DateTimeInput, DateTimePickerLayout, DateTimePickerSelectionMode, Dropdown, FormControl, Table } from "@rivtn/noseur";
import { Schemes, Utils } from "../../../../utils";
import { Elements } from "../../../shared/Elements";
import { ChartManager } from "../../../shared/ChartManager";
import AnalCard from "../../../shared/analytics/AnalCard";

export interface TeamAchievementAnalyticsProps {
    profile: IMember;
}

function TeamAchievementAnalytics(props: TeamAchievementAnalyticsProps) {

    const { profile } = props;
    const teamService = TeamService.getInstance();
    let { id: teamId = "" } = ReactRouterDom.useParams();
    const analLabels = i18nManager.Labels.teams.analytics;
    const [team, setTeam] = React.useState<ITeam>({} as any);
    const teamAnalyticsChartDataState = React.useState<ChartData>();
    const labels = i18nManager.Labels.teams.analytics.achievements_page;
    const [daysDifference, setDaysDifference] = React.useState<number>(0);
    const [teamAnalytics, setTeamAnalytics] = React.useState<ITeamAnalytics>();
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [teamAchievements, setTeamAchievements] = React.useState<ApiResponseData<ITeamAchievement>>({});

    React.useEffect(fetchInformation, []);

    React.useEffect(() => {
        setDaysDifference(DateHelper.getDaysBetweenDates(
            (searchParams.has("from") ? new Date(searchParams.get("from")!) : DateHelper.getStartOfMonth()),
            (searchParams.has("to") ? new Date(searchParams.get("to")!) : new Date())));
    }, [searchParams]);

    return (<div className="earnings analytics">
        <div className="header">
            <div className="l" style={{ display: "flex", flexDirection: "column" }}>
                <span className="t lined-limit"><i className="fa fa-arrow-left" onClick={() => window.history.back()} />
                    {i18nManager.Labels.teams.title + " - " + teamId + " - " + analLabels.title + " - " + labels.title}</span>
                <span className="lined-limit" style={{ marginLeft: 25, fontWeight: "normal" }}>
                    {team.name}{" "}
                </span>

            </div>
            <div className="queries">
                <Dropdown noIcon scheme={Schemes.OMNEHOST} formControlProps={{ className: "plan-dd", isFieldset: true, label: analLabels.country_currency, }}
                    selectedOptionIndex={(i18nManager.CountriesAndCurrencies?.findIndex((p) => p?.currency_code === (searchParams.get("curr") ?? "NGN")) ?? 0)}
                    textInputProps={{ style: { paddingLeft: 15 } }}
                    options={i18nManager.CountriesAndCurrencies} optionMap={{
                        value: "currency_code",
                        label: "{label} ({currency_name} - {currency_code})",
                    }} onSelectOption={(option) => {
                        Utils.updateSearchParams("curr", option.currency_code, setSearchParams, fetchInformation);
                    }} />
                <FormControl className="date-range-dd" isFieldset scheme={Schemes.OMNEHOST} label={analLabels.date_range} rightContent={"fa fa-calendar"} style={{ width: 360 }}>
                    <DateTimeInput fill leftLayout={DateTimePickerLayout.FINE_LEFT_LAYOUT} formatDate={(date) => Utils.formatToFineDate4(date)}
                        selectedDates={[(searchParams.has("from") ? new Date(searchParams.get("from")!) : DateHelper.getStartOfMonth()), new Date(searchParams.get("to") ?? Utils.formatToApiDate(new Date(), false, false)!)]}
                        selectionMode={DateTimePickerSelectionMode.RANGE} onSelectDate={(options) => {
                            Utils.updateSearchParamses({
                                "to": Utils.formatToApiDate(options.toDate!, false, false),
                                "from": Utils.formatToApiDate(options.fromDate!, false, false),
                            }, setSearchParams, fetchInformation);
                        }} />
                </FormControl>
            </div>
        </div>
        <div className="container" style={{ flexDirection: "column" }}>
            <div className="primary" style={{ flex: "unset" }}>
                <div className="anal-cards" style={{ marginLeft: -10 }}>
                    <AnalCard anal={teamAnalytics?.achievements?.trophies} desc={labels.total_trophies_won} analKey="count" cardColor={"#EBF4FE"}
                        icon="fa fa-trophy" title={labels.trophies} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.achievements?.first_place} desc={labels.top_of_the_tournament} analKey="count" cardColor={"#EBF4FE"}
                        icon="fa fa-trophy" title={labels.first_place} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.achievements?.second_place} desc={labels.first_runner_up_position} analKey="count" cardColor={"#EBF4FE"}
                        icon="fa fa-trophy" title={labels.second_place} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.achievements?.third_place} desc={labels.second_runner_up_position} analKey="count" cardColor={"#EBF4FE"}
                        icon="fa fa-trophy" title={labels.third_place} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.achievements?.total} desc={labels.team_awards}
                        daysDifference={daysDifference} analKey="count" cardColor={"#EBF4FE"} style={{ maxWidth: 150 }} />
                </div>
            </div>
            <div className="analytics" style={{ flex: 1 }}>
                <div className="container" style={{ marginTop: 0 }}>
                    <div className="primary" style={{ marginTop: -10, marginBottom: 0, flex: 0.7 }}>
                        {<ChartManager height={"unset"} type={ChartType.BAR} title={analLabels.team_anals} chartDataState={teamAnalyticsChartDataState} style={{ height: "100%", marginBottom: 10 }} />}
                    </div>
                    <div className="secondary" style={{ marginTop: 5, flex: 1 }}>
                        <div className="anal-table" style={{ margin: 10, display: "flex", flexDirection: "column" }}>
                            <div className="header">
                                <span className="t">{labels.all_achievements}</span>
                                <span className="link">{labels.export}</span>
                            </div>
                            {Elements.buildConfirmDialogForm(labels.query_inputs, (name: string, value: any, searching: any) => {

                            }, {}, undefined, { maxWidth: "70%", marginTop: 0, flexDirection: "row", alignItems: "center" }, undefined, {
                                marginRight: 15
                            })}
                            <Table stripedRows scheme={Schemes.OMNEHOST} data={teamAchievements.content} totalRecords={teamAchievements.total_elements} dataRefreshKeys={["external_id", "created_at"]}
                                style={{ flex: 1 }} rowsPerPage={200} loadingState={Elements.LOADING_STATE} emptyState={Elements.buildEmptyListView("fa fa-trophy", (<span>
                                    {labels.empty_label_parts.no_achievements_found}{" "}
                                    <ReactRouterDom.NavLink to="/tournaments">{labels.empty_label_parts.participate}</ReactRouterDom.NavLink>{" "}
                                    {labels.empty_label_parts.in_a_tour}
                                </span>), { marginTop: 50 })}>
                                <Column className="table-c" header={labels.table.headers.date_achieved} dataKey="date_achieved" template={(v) => Utils.formatToFineDate(v, true)} />
                                <Column className="table-c" header={labels.table.headers.tournament} dataKey="tournament" template={(v: ITournamentEdition) => {
                                    let link = EarningService.buildTransactionSourceLink({ source_data: { type: TransactionSourceType.TOURNAMENT, extra_data: { public_id: v.tournament.public_id } } as any });
                                    return (<div style={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                                        <img alt={v.name} src={v.logo_url} style={{ width: 20, height: 20, marginRight: 10, borderRadius: "100%" }} />
                                        <a target="_blank" href={link}>{v.name}</a>
                                    </div>);
                                }} />
                                <Column className="table-c" header={labels.table.headers.achievement} dataKey="achievement" template={(v: ITeamAchievementDetail) => {
                                    let label: string = labels.others;
                                    if (v.type === TeamAchievementType.PLACE) {
                                        label = labels.query_inputs.find((i) => i.name === "place")?.options?.find((o) => o.value === v.place)?.label ?? v.place ?? "";
                                        if (v.place === TeamAchievementPlace.CUSTOM_PLACE) {
                                            label = v.extra_data?.place_value ?? label;
                                        }
                                        label = label + " - " + v.title;
                                    } else if (v.type === TeamAchievementType.TROPHY) {
                                        label = v.title + ` (${v.receiver?.display_name})`;
                                    }
                                    return (<span>{label}</span>);
                                }} />
                                <Column className="table-c" header={labels.table.headers.badge} dataKey="badge_image_location" template={(v: string) => {
                                    return (<img alt="achievement" src={v}  style={{ width: 20, height: 20 }} />);
                                }} />
                            </Table>
                            <div className="pagination">
                                {Elements.buildPaginator(teamAchievements ?? {},
                                    ({ currentPage }, size) => Utils.updateSearchParamses({ "page": currentPage, size }, setSearchParams, fetchInformation),
                                    parseInt(searchParams.get("page") ?? "1"), { margin: 15, marginBottom: 5 })}
                                {Elements.buildSorter(labels.sorts, (sort) => Utils.updateSearchParamses({ sort }, setSearchParams, fetchInformation), labels.sorts[0].label)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>);

    function fetchInformation() {
        teamService.getTeamByPublicId(teamId!).then(({ sanitized }: SanitizedResponse<ITeam>) => {
            setTeam(sanitized);
        }).catch(BaseService.reportError);

        const params = {
            currency_code: searchParams.get("curr") ?? "NGN",
            to: searchParams.get("to") ?? Utils.formatToApiDate(new Date())!,
            fields: ["earnings.total", "tournaments.entered", "achievements.total"],
            from: searchParams.get("from") ?? Utils.formatToApiDate(DateHelper.getStartOfMonth())!,
        };
        setTeamAnalytics(undefined);
        teamService.getTeamAnalytics(teamId, params).then(({ sanitized }: SanitizedResponse<ITeamAnalytics>) => {
            setTeamAnalytics(sanitized);
        }).catch(BaseService.reportError);

        teamAnalyticsChartDataState[1](undefined);
        teamService.queryAnalyticsChartData(teamId, params).then(({ apiResponse }: SanitizedResponse<any>) => {
            teamAnalyticsChartDataState[1](apiResponse.data!);
        }).catch(BaseService.reportError);

        setTeamAchievements({});
        teamService.queryTeamAchievements(teamId, params).then(({ apiResponse }: SanitizedResponse<any>) => {
            setTeamAchievements(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

}

export default TeamAchievementAnalytics;
